var exports = {
  "zr": "x804f0401--ad1e0a--root",
  "B7": "x804f0401--ad1e0a--info-container",
  "my": "x804f0401--ad1e0a--avatar",
  "UU": "x804f0401--ad1e0a--name",
  "pq": "x804f0401--ad1e0a--info",
};

module.exports = exports;
